import { CUSTOMER_COS } from './constants.js'

export const state = {
	[CUSTOMER_COS]: {
		isLoading: false,
		objects: []
	}
}
